// Mirrors the backend `editBusiness` websiteURL rule: after trimming, the value
// must parse as a URL and use an http:/https: protocol. An empty value is valid
// (it clears the website), so callers should special-case empty before calling.
export function isValidWebsiteUrl(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed === "") return true;
  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
